import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface PageGuardProps {
  children: ReactNode;
  isEnabled: boolean;
}

/**
 * PageGuard component that conditionally renders children or redirects to under-development page
 * Use this to wrap route components that should check if a page is enabled
 */
export default function PageGuard({ children, isEnabled }: PageGuardProps) {
  if (!isEnabled) {
    return <Navigate to="/under-development" replace />;
  }

  return <>{children}</>;
}
